import React from "react";

const ContactUs = () => {
  return (
    <div className="cmnTermsPage">
      <div className="cmnTermsDiv">
        <h1>Contact Us</h1>
        <div style={{ padding: "0 20px" }}>
          <p className="cmnTermsContent">
            <div>
              <p>
                Reach us by phone
                <br />
                <span style={{ fontWeight: "bold", color: "#1F6BBD" }}>
                  +91-777-780-4646
                </span>
              </p>
              <p>
                Reach us by E-mail: A member of SmarterHomes support team will
                respond as soon as possible.{" "}
              </p>
              <p>
                For Sales inquiries: 
                <span className="cmnTermsLink">sales@smarterhomes.com</span>
                <br />
                For Product support: 
                <span className="cmnTermsLink">support@smarterhomes.com</span>
                <br />
                For Careers: 
                <span className="cmnTermsLink">careers@smarterhomes.com</span>
                <br />
                For any grievance: 
                <span className="cmnTermsLink">grievance@smarterhomes.com</span>
              </p>
            </div>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
